import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setPersonalisedMenteeEmailersCurrentPage } from 'features/communicationManagement';
import Pagination from 'components/Pagination';
import styles from './PersonalisedMenteeEmailersPagination.module.scss';

export default function PersonalisedMenteeEmailersPagination({
  currentPage,
  pageCount,
}) {
  const dispatch = useDispatch();

  const handlePageChange = useCallback(
    (event) => {
      dispatch(setPersonalisedMenteeEmailersCurrentPage(event.selected + 1));
    },
    [dispatch]
  );

  if (pageCount > 0) {
    return (
      <Pagination
        onPageChange={handlePageChange}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        className={styles.paginate}
      />
    );
  }
  return null;
}
